import React from 'react';
import config from '../../preorder/configs/config';

export default () => (
  <img src={`${config.RESOURCE_URI}MenuAd/edm_202304_hsz.jpg`} alt="" width="100%" />
);
